import { useQuery } from "@tanstack/react-query";
export const createContestsEditionLogsQueries = (requests, queryClient) => ({
    useListContestsEditionLogs: (params, options) => {
        return useQuery({
            queryKey: ["contestsEditionLogs", params],
            queryFn: () => requests.listContestsEditionLogs(params),
            ...options,
        });
    },
});
//# sourceMappingURL=contestsEditionLogs.js.map